<template>
    <div class="free-orders">
        <el-row>
            <el-col :span="24">
                <el-alert
                        title="温馨提示"
                        type="success"
                        close-text="知道了"
                        show-icon>
                    <p>请首先授权淘宝联盟。 <a style="color: #ff0036"
                                     href="https://admin.tk.xcx.yftaoke.com/highcommission_settings.html"
                                     target="_blank">点击去授权</a></p>
                    <p>此处生成的appid和页面路径，可以设置到首页的模块，具体可以参考界面设置的教程</p>
                    <p><a style="color: #ff0036"
                          href="https://www.yuque.com/yifakeji/irpssl/hhpo44"
                          target="_blank">界面设置教程</a></p>
                </el-alert>
                <div class="grid-content bg-purple-dark">
                    <el-form ref="form-one" :model="item" :rules="rules" label-width="150px">
                        <el-form-item label="红包类型" prop="activityMaterialId">
                            <el-col :span="12">
                                <el-select class="form-item" v-model="item.activityMaterialId" placeholder="请选择红包类型">
                                    <el-option
                                            v-for="item in channelTypes"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="pid">
                            <el-col :span="12">
                                <el-input v-model="item.pid" placeholder="请输入pid，不填的话走，设置的默认pid"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="淘口令图片链接">
                            <el-col :span="12">
                                <el-input v-model="item.taoTokenLogoUrl" placeholder="淘口令图片链接，也可以不填"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="淘口令文案">
                            <el-col :span="12">
                                <el-input v-model="item.taoTokenText" placeholder="淘口令文案，也可以不填"></el-input>
                            </el-col>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" size="medium" @click="onSubmit('form-one')">生成</el-button>
                            <el-button size="medium">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form ref="form" :model="result" label-width="150px">
                    <el-form-item label="AppId">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.appId">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.appId"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="小程序页面路径">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.wxMiniprogramPath">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.wxMiniprogramPath"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="网页链接">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.shortClickUrl">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.shortClickUrl"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="小程序码">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.wxQrcodeUrl">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.wxQrcodeUrl"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="淘口令">
                        <el-col :span="12">
                            <el-input placeholder="" class="input-with-select" v-model="result.taoToken">
                                <el-button type="primary" slot="append"
                                           v-clipboard:copy="result.taoToken"
                                           v-clipboard:success="onCopy"
                                           v-clipboard:error="onError">一键复制
                                </el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                </el-form>

            </el-col>
        </el-row>


    </div>

</template>
<script>
    import {eleApi} from "../../common/eleApi";

    export default {
        name: 'promotion',
        data() {
            return {
                item: {},
                channelTypes: [
                    {
                        name: '饿了么微信推广',
                        id: "20150318020002192"
                    },
                    {
                        name: '饿了么餐饮红包',
                        id: "1579491209717"
                    },
                    {
                        name: '饿了么新零售超市',
                        id: "1585018034441"
                    }
                ],
                result: {},
                rules: {
                    activityMaterialId: [
                        {required: true, message: '请选择红包类型', trigger: 'blur'},
                    ]
                }
            }

        },
        methods: {
            onSubmit(formName) {
                var that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        eleApi.createElePromotion.call(that, that.item, function (res) {
                            if (res.result.item) {
                                that.successMsg("生成成功");
                                that.result = res.result.item;
                            }
                        })
                    }
                })

            },
            onCopy() {
                this.successMsg("复制成功");
            },
            onError() {
                this.failMsg("复制失败")
            },
        }
    }

</script>
<style lang="scss">

    .form-item {
        width: 100% !important;
    }

</style>